<script lang="ts" setup>
import type { EventRsvpConfirmationBody } from "@anggunpraya-templates/base/app/schemas/event";
import { eventRsvpConfirmation } from "@anggunpraya-templates/base/app/schemas/event";

const props = defineProps<{
  isRsvpDisabled: boolean;
  isLoading: boolean;
  renderedFormFields: EventRsvpConfirmationBody["rsvp_activities"];
}>();

const { xs } = useBreakpointTailwind();

const state = defineModel<EventRsvpConfirmationBody>({
  default: () => ({
    status: "unconfirmed",
    rsvp_activities: [],
  }),
});

const formRef = useTemplateRef("formRef");

const attendingActivities = computed(() => {
  return props.renderedFormFields.filter(item => item.rsvp_status === "attending");
});

const isRenderedFormFieldsOdd = computed(() => {
  return attendingActivities.value.length % 2 === 1;
});

defineExpose({
  clear: () => {
    formRef.value?.clear();
  },
});
</script>

<template>
  <UForm
    ref="formRef"
    :state="state"
    :schema="eventRsvpConfirmation"
    class="flex flex-col items-center justify-center mt-6"
    @error="highlightErrorField"
  >
    <div
      class="grid w-full gap-4 px-4 sm:px-0 sm:gap-8"
      :class="{
        'grid-cols-2': attendingActivities.length >= 2,
      }"
    >
      <template
        v-for="(item, index) in props.renderedFormFields"
        :key="item.egra_id"
      >
        <UFormField
          v-if="state.rsvp_activities?.[index] && item.rsvp_status === 'attending'"
          label="Jumlah Tamu (Pax)"
          class="text-center"
          :name="`rsvp_activities.${index}.pax`"
          :description="attendingActivities.length > 1 ? item.rsvp_activity.name : ''"
          :size="xs ? 'md' : 'sm'"
          :class="{
            'last:md:col-span-2': isRenderedFormFieldsOdd,
          }"
          :ui="{
            label: 'text-center w-full text-primary-800 text-sm md:text-base',
            description: 'text-center text-primary text-xs md:text-sm',
          }"
        >
          <div class="mt-2">
            <UInputNumber
              v-model="state.rsvp_activities[index].pax"
              type="number"
              placeholder="Tamu (Pax)"
              block
              :max="10"
              :disabled="isLoading"
            />
          </div>
        </UFormField>
      </template>
    </div>

    <UButton
      type="submit"
      label="Konfirmasi Kehadiran"
      class="rounded-full w-fit mt-10"
      variant="soft"
      block
      :loading="isLoading"
    />
  </UForm>
</template>
